import React from 'react';
type Props = {};

const SignHereIcon = (props: Props) => {
  return (
    <svg fill="none" height="22" viewBox="0 0 18 22" width="18" xmlns="http://www.w3.org/2000/svg">
      <path
        clipRule="evenodd"
        d="M1 2.90114L3.83744 1L8.96059 8.07224L14.0837 1L17 2.90114L11.0887 10.962L17 19.0989L14.0837 21L8.96059 13.9278L3.83744 21L1 19.0989L6.83251 10.962L1 2.90114Z"
        fill="currentColor"
        fillRule="evenodd"
        stroke="#FCFCFC"
      />
    </svg>
  );
};

export default SignHereIcon;
